import Service from '../service'
import ProviredApvMdl from '@/models/HumanResource/HrPreviredApv'

export default class extends Service {
    static model = ProviredApvMdl
}
